import { 
  signInWithEmailAndPassword as firebaseSignIn,
  signOut as firebaseSignOut,
  onAuthStateChanged as firebaseOnAuthStateChanged
} from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { auth } from './firebaseConfig';

// Initialize Firebase Functions
const functions = getFunctions();
const verifyAdmin = httpsCallable(functions, 'verifyAdmin');

// Sign in with email and password
export const signInWithEmailAndPassword = async (email, password) => {
  try {
    const userCredential = await firebaseSignIn(auth, email, password);
    const user = userCredential.user;
    
    // Verify admin status from server-side
    const result = await verifyAdmin();
    if (!result.data.isAdmin) {
      await firebaseSignOut(auth);
      throw new Error('Access denied. Admin privileges required.');
    }
    
    return user;
  } catch (error) {
    throw error;
  }
};

// Sign out
export const signOut = async () => {
  try {
    await firebaseSignOut(auth);
  } catch (error) {
    throw error;
  }
};

// Check if current user is admin using server-side validation
export const isAdmin = async (user) => {
  if (!user) return false;
  
  try {
    const result = await verifyAdmin();
    return result.data.isAdmin;
  } catch (error) {
    console.error('Error verifying admin status:', error);
    return false;
  }
};

// Get current user
export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebaseOnAuthStateChanged(auth, user => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
};

// Listen to auth state changes
export const onAuthStateChanged = (callback) => {
  return firebaseOnAuthStateChanged(auth, callback);
};

// Verify current user's admin status
export const verifyAdminStatus = async () => {
  try {
    const result = await verifyAdmin();
    return result.data;
  } catch (error) {
    return { isAdmin: false };
  }
};
